import LegalLinks from "./LegalLinks";

const MoveboothLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="86"
    height="12"
    viewBox="0 0 86 12"
    fill="none"
  >
    <g opacity="0.96">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.7714 7.6875C50.7714 10.1214 48.9403 12 46.7188 12C45.5828 12 44.7518 11.6245 44.1921 11.0036V11.7713H41.649V0H44.1921V4.37137C44.7518 3.75052 45.5828 3.375 46.7188 3.375C48.9403 3.375 50.7714 5.25337 50.7714 7.6875ZM48.228 7.6875C48.228 6.46214 47.3803 5.6945 46.21 5.6945C45.0401 5.6945 44.1921 6.46214 44.1921 7.6875C44.1921 8.91286 45.0401 9.6805 46.21 9.6805C47.3803 9.6805 48.228 8.91286 48.228 7.6875Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9632 9.73107C37.6492 9.62137 38.19 9.26997 38.4635 8.86178L40.2553 10.2925C39.589 11.147 38.5941 11.6893 37.3022 11.896C34.4419 12.354 32.3491 10.7845 31.9351 8.38356C31.5211 5.98237 33.0079 3.83999 35.6506 3.41701C38.0931 3.02593 40.2136 4.55757 40.6333 6.99118C40.6917 7.32936 40.7138 7.6569 40.6998 7.97407L34.7617 8.92453C35.2239 9.71162 36.0431 9.87863 36.9632 9.73107ZM37.9964 6.55187C37.5676 5.66027 36.7565 5.44217 36.0035 5.56276C35.05 5.71551 34.4925 6.26867 34.3999 7.12785L37.9964 6.55187Z"
        fill="white"
      />
      <path
        d="M12.7176 11.7713V6.75622C12.7176 4.71421 11.4459 3.37474 9.49581 3.37474C8.29194 3.37474 7.5118 3.79953 7.03693 4.4528C6.56232 3.76686 5.8161 3.37474 4.81548 3.37474C3.67945 3.37474 2.93349 3.79953 2.54341 4.35477V3.60347H0V11.7713H2.54341V7.16468C2.54341 6.20073 3.01828 5.62889 3.866 5.62889C4.68034 5.62889 5.08684 6.15171 5.08684 6.96862V11.7713H7.63078V7.16468C7.63078 6.20073 8.10539 5.62889 8.95337 5.62889C9.76717 5.62889 10.1742 6.15171 10.1742 6.96862V11.7713H12.7176Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2352 3.375C15.7424 3.375 13.7414 5.25337 13.7414 7.6875C13.7414 10.1214 15.7424 12 18.2352 12C20.728 12 22.7287 10.1214 22.7287 7.6875C22.7287 5.25337 20.728 3.375 18.2352 3.375ZM18.2352 5.7596C19.3373 5.7596 20.1853 6.52749 20.1853 7.6875C20.1853 8.84725 19.3373 9.61515 18.2352 9.61515C17.1328 9.61515 16.2851 8.84725 16.2851 7.6875C16.2851 6.52749 17.1328 5.7596 18.2352 5.7596Z"
        fill="white"
      />
      <path
        d="M31.7582 3.60347L28.6212 11.7713H25.7386L22.6014 3.60347H25.4161L27.1797 8.78164L28.9432 3.60347H31.7582Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.0418 3.375C53.549 3.375 51.5483 5.25337 51.5483 7.6875C51.5483 10.1214 53.549 12 56.0418 12C58.5346 12 60.5353 10.1214 60.5353 7.6875C60.5353 5.25337 58.5346 3.375 56.0418 3.375ZM56.0418 5.7596C57.1442 5.7596 57.9919 6.52749 57.9919 7.6875C57.9919 8.84725 57.1442 9.61515 56.0418 9.61515C54.9397 9.61515 54.0917 8.84725 54.0917 7.6875C54.0917 6.52749 54.9397 5.7596 56.0418 5.7596Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.113 7.6875C61.113 5.25337 63.114 3.375 65.6068 3.375C68.0994 3.375 70.1001 5.25337 70.1001 7.6875C70.1001 10.1214 68.0994 12 65.6068 12C63.114 12 61.113 10.1214 61.113 7.6875ZM67.5566 7.6875C67.5566 6.52749 66.7089 5.7596 65.6068 5.7596C64.5044 5.7596 63.6567 6.52749 63.6567 7.6875C63.6567 8.84725 64.5044 9.61515 65.6068 9.61515C66.7089 9.61515 67.5566 8.84725 67.5566 7.6875Z"
        fill="white"
      />
      <path
        d="M74.4374 8.84699V5.95565H76.184V3.60347H74.4374V0.909491L71.894 1.31639V3.60347H70.5373V5.95565H71.894V8.84699C71.894 11.1343 72.8607 12.098 76.184 11.7713V9.54953C75.065 9.61489 74.4374 9.54953 74.4374 8.84699Z"
        fill="white"
      />
      <path
        d="M85.7143 6.75622V11.7713H83.1709V7.11567C83.1709 6.1027 82.5094 5.62889 81.6954 5.62889C80.7629 5.62889 80.1184 6.15171 80.1184 7.31172V11.7713H77.5752V0.407676L80.1184 0V4.37137C80.5763 3.76686 81.424 3.37474 82.5434 3.37474C84.256 3.37474 85.7143 4.55083 85.7143 6.75622Z"
        fill="white"
      />
    </g>
  </svg>
);

const ImageCounter = ({ count }) => (
  <div className="flex items-end gap-1">
    <span className="text-2xl font-headline font-bold text-white leading-none translate-y-[2px]">
      {count.toLocaleString()}
    </span>
    <div className="flex flex-col leading-none">
      <span className="text-[10px] font-headline font-medium text-white/[0.72] tracking-[0.2px]">
        MOVES
      </span>
      <span className="text-[10px] font-headline font-medium text-white/[0.72] tracking-[0.2px]">
        MADE
      </span>
    </div>
  </div>
);

const GalleryFooter = ({ slug, totalCount }) => {
  const utmUrl = `https://www.movebooth.com/?utm_source=app&utm_medium=gallery&utm_campaign=${slug}`;
  const hasImages = totalCount > 0;

  return (
    <div className={`fixed left-0 bottom-0 flex items-end h-[80px] px-6 pb-6 z-10 w-full bg-gradient-to-b from-transparent backdrop-blur-[1px] to-black/80 ${hasImages ? 'justify-between' : 'justify-center'}`}>
      {/* Logo + legal links - bottom left when has images, centered when
          empty. Stacked rather than inline so the counter keeps its own
          column on a 320px phone. */}
      <div className={`flex flex-col gap-2 ${hasImages ? 'items-start' : 'items-center'}`}>
        <a
          href={utmUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MoveboothLogo />
        </a>
        <LegalLinks />
      </div>

      {/* Image count - bottom right (only show when gallery has images) */}
      {hasImages && (
        <ImageCounter count={totalCount} />
      )}
    </div>
  );
};

export default GalleryFooter;
